import {OverallStatement} from "../../components";
import React from "react";

/**
 * Component for rendering the energy statement.
 *
 * @return {React.ReactElement} A JSX element representing the energy statement.
 */
export const EnergyStatement = () => {
  return <OverallStatement statementType="energy" />;
};
